import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface PopupState {
  isVisible: boolean;
  isAdded: boolean;
  hotelId: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class WishlistHotelPopupService {
  private popupState = new Subject<PopupState>();
  private hideTimer: ReturnType<typeof setTimeout> | null = null;
  popupState$ = this.popupState.asObservable();

  showPopup(isAdded: boolean, hotelId: number) {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }

    this.popupState.next({ isVisible: true, isAdded, hotelId });

    this.hideTimer = setTimeout(() => {
      this.popupState.next({ isVisible: false, isAdded, hotelId });
      this.hideTimer = null;
    }, 3000);
  }
}
